import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '../icon.js';

function BagNoChecked(props) {
  return /* @__PURE__ */ jsx(Icon, { ...props, children: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-labelledby": "bag-no-checked-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      role: "img",
      children: [
        /* @__PURE__ */ jsx("title", { id: "bag-no-checked-icon", children: "A bag-no-checked icon" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.7229 20.8263L2.92394 1.02734L1.86328 2.088L4.7754 5.00012H4.50011C3.67169 5.00012 3.00011 5.6717 3.00011 6.50012V17.5001C3.00011 18.1545 3.41918 18.7111 4.0036 18.916C4.00129 18.9437 4.00011 18.9718 4.00011 19.0001C4.00011 19.5524 4.44783 20.0001 5.00011 20.0001C5.5524 20.0001 6.00011 19.5524 6.00011 19.0001H18.0001C18.0001 19.5524 18.4478 20.0001 19.0001 20.0001C19.2189 20.0001 19.4213 19.9299 19.5859 19.8107L21.6623 21.887L22.7229 20.8263ZM14.7001 14.9248L13.5001 13.7248V16.0001H14.7001V14.9248ZM10.7001 10.9248L9.50011 9.72484V16.0001H10.7001V10.9248ZM5.50011 8.00012H6.70011V16.0001H5.50011V8.00012Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.7001 8.00012V9.97527L17.5001 12.7753V8.00012H18.7001V13.9753L21.0001 16.2753V6.50012C21.0001 5.67169 20.3285 5.00012 19.5001 5.00012H14.0001V4.00012C14.0001 3.44784 13.5524 3.00012 13.0001 3.00012H11.0001C10.4478 3.00012 10.0001 3.44784 10.0001 4.00012V5.00012H9.72497L13.5001 8.77527V8.00012H14.7001ZM11.2001 4.80012V4.20012H12.8001V4.80012H11.2001Z"
          }
        )
      ]
    }
  ) });
}

export { BagNoChecked as default };
